import type { IWebConfig } from '~/types/config.types'

const config = window?.config

const webConfig: IWebConfig = {
  auth: {
    redirect_uri: config?.AUTH0_CALLBACK_URI || import.meta.env.VITE_AUTH0_CALLBACK_URI,
    logout_uri: config?.AUTH0_LOGOUT_URI || import.meta.env.VITE_AUTH0_LOGOUT_URI,
    silent_redirect_uri: config?.AUTH0_SILENT_REDIRECT_URI || import.meta.env.VITE_AUTH0_SILENT_REDIRECT_URI,
  },
  api: {
    platform_api_url: config?.PLATFORM_API_URL || import.meta.env.VITE_PLATFORM_API_URL,
  },
  app: {
    envName: config?.ENV_NAME || import.meta.env.VITE_ENV_NAME || import.meta.env.MODE || 'localdev',
    production: import.meta.env.PROD,
    gaMeasurementId: config?.GA_MEASUREMENT_ID || import.meta.env.VITE_GA_MEASUREMENT_ID,
    version: config?.VERSION || import.meta.env.VITE_BUILD_ID,
  },
  access: {
    access_client_url: config?.ACCESS_CLIENT_URL || import.meta.env.VITE_ACCESS_CLIENT_URL,
  },
}

// debug
// console.log(' ------------ ENVIRONMENT ------------')
// console.log(`auth domain: ${webConfig.auth.domain}`)
// console.log(`auth client id: ${webConfig.auth.client_id}`)
// console.log(`envName: ${webConfig.app.envName}`)
// console.log(`production: ${webConfig.app.production}`)
// console.log(`import.meta.env: ${JSON.stringify(import.meta.env)}`)
// console.log(' ------------ ENVIRONMENT ------------')

export default webConfig
